<script>
import VueContext from 'vue-context';

export default {
    name: "MasterDataPortal",

    components: {
        VueContext
    },
}
</script>
<style scoped>
@import  '~vue-context/dist/css/vue-context.css';
</style>
<template>
  <tail-base-layout>
      <template v-slot:content>
        <div class="flex flex-wrap mt-4">
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.clinics.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-green-600"><i class="fas fa-clinic-medical fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Clinic Set up</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-orange-100 border-b-4 border-orange-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.templates-category.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-orange-600"><i class="fas fa-laptop-medical fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Template Categories</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-yellow-100 border-b-4 border-yellow-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.templates.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-yellow-600"><i class="fas fa-notes-medical fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Templates</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-blue-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu14.open($event)">
                            <div class="flex-shrink pr-4">
                                <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-microscope fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Lab Setup</h5>
                            </div>
                        </div>
                        <vue-context ref="menu14">
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `master-data.lab-setup.lab-test-components.index` }">Lab Test Components</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `master-data.lab-setup.lab-test-components-reporting.index` }">Lab Test Component Reporting</router-link>
                            </li>
                            <!-- <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `master-data.lab-setup.lab-test-items.index` }">Lab Test Items</router-link>
                            </li> -->
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `master-data.lab-setup.item-consumable-deduction.index`}">Lab Consumable Items</router-link>
                            </li>
                        </vue-context>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-3">
                    <!--Metric Card-->
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1" title="Right click for options">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu.open">
                            <div class="flex-shrink pr-4">
                                <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-user-md fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Consultants Set up</h5>
                            </div>
                            <vue-context ref="menu">
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.consultants.index`}">Consultants</router-link>
                                </li>
                                <li class="hover:bg-gray-300">
                                    <router-link :to="{ name: `master-data.consultant-items.index`}">Specific consultant Items</router-link>
                                </li>
                            </vue-context>
                        </div>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <!--Metric Card-->
                    <div class="bg-red-100 border-b-4 border-red-500 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu1.open">
                            <div class="flex-shrink pr-4">
                                <div class="rounded-full p-5 bg-red-600"><i class="fas fa-bed fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Wards Setup</h5>
                            </div>
                            <vue-context :close-on-scroll="true" ref="menu1">
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.wards.service-packages.index`}">Ward Service Package</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-300">
                                    <router-link :to="{ name: `master-data.wards.floors.index`}">Create/Modify Floors</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-300">
                                    <router-link :to="{ name: `master-data.wards.setup.index`}">Create/Modify Wards</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-300">
                                    <router-link :to="{ name: `master-data.wards.beds.index`}">Create/Modify Beds</router-link>
                                </li>
                            </vue-context>
                        </div>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <!--Metric Card-->
                    <div class="bg-blue-200 border-b-4 border-blue-500 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu2.open">
                            <div class="flex-shrink pr-4">
                                <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-hospital-alt fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Morgue Setup</h5>
                            </div>
                            <vue-context :close-on-scroll="true" ref="menu2">
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.morgue.service-packages.index`}">Morgue Service Package</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.morgue.beds.index`}">Morgue Beds</router-link>
                                </li>
                            </vue-context>
                        </div>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-3">
                    <!--Metric Card-->
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu3.open">
                            <div class="flex-shrink pr-4">
                                <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-hospital fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Theatre Set up</h5>
                            </div>
                            <vue-context :close-on-scroll="true" ref="menu3">
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.theatres.service-packages.index`}">Service Package</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.theatres.rooms.index`}">Theatre Rooms</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-400">
                                    <router-link 
                                        :to="{ 
                                            name: `master-data.theatres.procedure-pricing.index` 
                                            }">Theatre Procedure Pricing</router-link>
                                </li>
                            </vue-context>
                        </div>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-teal-100 border-b-4 border-teal-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.employee-setup.employees.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-teal-600"><i class="fas fa-users fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Employee Set up</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu5.open">
                            <div class="flex-shrink pr-4">
                                <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-compass fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Geographic Set up</h5>
                            </div>
                            <vue-context :close-on-scroll="true" ref="menu5">
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.geographic.counties.index`}">County</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.geographic.locations.index`}">Location</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ name: `master-data.geographic.sub-locations.index`}">Sub-location</router-link>
                                </li>
                            </vue-context>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-orange-200 border-b-4 border-orange-500 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu6.open">
                            <div class="flex-shrink pr-4">
                                <div class="rounded-full p-5 bg-orange-600">
                                    <i class="fas fa-clinic-medical fa-2x fa-inverse"></i>
                                </div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Organizations Set up</h5>
                            </div>
                            <vue-context :close-on-scroll="true" ref="menu6">
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ 
                                            name: `master-data.organizations.setup.index`
                                        }">Organization Setup</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ 
                                            name: `master-data.organizations.cover-types.index`
                                        }">Insurance Cover Types</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ 
                                            name: `master-data.organizations.insurance-item-prices.index`
                                        }">Insurance Item Prices</router-link>
                                </li>
                                <li class="border-b hover:bg-gray-400">
                                    <router-link :to="{ 
                                            name: `master-data.organizations.benefit-packages.index`
                                        }">Benefit Packages</router-link>
                                </li>
                            </vue-context>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-200 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu7.open">
                            <div class="flex-shrink pr-4">
                                <div class="rounded-full p-5 bg-indigo-600">
                                    <i class="fas fa-prescription-bottle fa-2x fa-inverse"></i>
                                </div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Items Set up</h5>
                            </div>
                        </div>
                        <vue-context :close-on-scroll="true" ref="menu7">
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `master-data.items-setup.item-grouping.index`}">Item Grouping</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `master-data.items-setup.specific-cash-items.index`}">Specific Cash Items</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `master-data.lab-setup.item-consumable-deduction.index`}"> Item Charges/Consumables</router-link>
                            </li>
                        </vue-context>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-red-200 border-b-4 border-red-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.vitals-parameters.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-red-600"><i class="fas fa-file-medical-alt fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Vitals Parameters Set up</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.questionaires.index`}">
                            <div class="flex flex-row items-center" >
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-question fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Questionaire</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.imaging.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-blue-500"><i class="fas fa-images fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Imaging</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-purple-100 border-b-4 border-purple-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.immunization.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-purple-500"><i class="fas fa-syringe fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Immunizations</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-200 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.voucher-deductions.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-600">
                                        <i class="fas fa-list fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Voucher Deductions</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2" 
                    v-if="$root.checkAuth(`master-data.custom-messages.index`)">
                    <div class="bg-indigo-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.custom-messages.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-blue-500"><i class="fas fa-ad fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600"> Custom Messages</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-200 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.hospitaldocuments.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-600">
                                        <i class="fas fa-list fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Hospital Documents</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div> <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-200 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.departments.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-600">
                                        <i class="fas fa-list fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Departments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
      </template>
</tail-base-layout>
</template>